module.exports = __webpack_public_path__ + "img/yygl.8be5cf65.svg";